import Vue from 'vue'
import Router from 'vue-router'
import AprobarTYC from '../views/AprobarTYC.vue'
const FormReport = () => import('../views/FormReport')
const NotFound = () => import('../views/NotFound')
const AutorizarAsociacion = () => import('../views/AutorizarAsociacion')
Vue.use(Router)

export default new Router({
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/Reportes/:id',
            name: 'Descarga de Reportes',
            component: FormReport
        },
        {
            path: '/AutorizarAsociacion/:id',
            name: 'Autorización de asociación a Multiusuario',
            component: AutorizarAsociacion
        },
        {
            path: '/AprobarTerminosYCondiciones/:id',
            name: 'Aprobación de términos y condiciones',
            component: AprobarTYC
        },
        {
            path: '/*',
            name: 'NotFound',
            component: NotFound
        }
    ]
})
